<template>
  <v-row>
    <v-col class="px-0" cols="12">
      <v-slider
        class="px-0"
        dense
        thumb-label
        :value="sliderNumber"
        :disabled="disabled"
        :max="maxValue"
        :min="minValue"
        :rules="sliderRules"
        :step="sliderStepSize"
        @change="updateSliderValue"
      >
        <template #thumb-label="{ value }">
          {{ factorValue(value) }}
        </template>
      </v-slider>
      <v-alert v-if="disabled" color="primary" dense outlined>
        <span class="slider-text">
          {{ disabledMessage }}
        </span>
      </v-alert>
    </v-col>
    <div
      class="d-flex flex-row justify-space-between align-start priceContainer mb-3"
    >
      <div class="d-flex flex-2 flex-column align-start">
        <span class="slider-text">
          {{ minTitle }}
        </span>
        <span class="font-weight-medium">
          {{ currency }} {{ factorValue(minValue) }}
        </span>
      </div>
      <v-text-field
        dense
        class="price-text-field"
        :value="inputValue"
        type="number"
        :step="sliderStepSize / factor"
        :rules="rules"
        outlined
        :prefix="currency"
        :min="minValue / factor"
        :max="maxValue / factor"
        @input="onTextInput"
      />
      <div class="d-flex flex-2 flex-column align-end">
        <span class="slider-text">
          {{ maxTitle }}
        </span>

        <span class="font-weight-medium">
          {{ currency }} {{ factorValue(maxValue) }}
        </span>
      </div>
    </div>
  </v-row>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'OverrideSlider',
  props: {
    currency: {
      required: false,
      type: String,
      default: '',
    },
    sliderValue: {
      required: true,
      type: [Number, String],
      default: 0,
    },
    sliderStepSize: {
      required: false,
      type: Number,
      default: 1,
    },
    decimals: {
      required: false,
      type: Number,
      default: 0,
    },
    disabledMessage: {
      required: false,
      type: String,
      default: '',
    },
    minValue: {
      required: false,
      type: Number,
      default: 0,
    },
    maxValue: {
      required: false,
      type: Number,
      default: 10,
    },
    minTitle: {
      required: false,
      type: String,
      default: '',
    },
    maxTitle: {
      required: false,
      type: String,
      default: '',
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    sliderRules: {
      required: false,
      type: Array,
      default: () => [],
    },
    power: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rules: [
        (value) =>
          parseFloat(value) <= this.factorValue(this.maxValue) ||
          this.$t('baseOverwriteModal.overMaximum'),
        (value) =>
          parseFloat(value) >= this.factorValue(this.minValue) ||
          this.$t('baseOverwriteModal.belowMinimum'),
      ],
    }
  },
  computed: {
    factor() {
      return 10 ** this.power || 1
    },
    sliderNumber() {
      if (typeof this.sliderValue === 'string') {
        try {
          const float = parseFloat(this.sliderValue)
          return float
        } catch (e) {
          console.error(e)
          return this.sliderValue
        }
      }
      return this.sliderValue
    },
    inputValue() {
      return this.factorValue(this.sliderValue)
    },
  },

  methods: {
    factorValue(value) {
      const type = typeof value
      if (type === 'string') {
        try {
          const float = parseFloat(value)
          return (float / this.factor).toFixed(this.decimals)
        } catch (e) {
          console.error(e)
        }
      }
      return (value / this.factor).toFixed(this.decimals)
    },
    updateSliderValue(value) {
      this.$emit('updateSliderValue', value)
    },
    onTextInput(value) {
      this.debounceInput(value)
    },
    debounceInput: _.debounce(function (value) {
      try {
        const float = parseFloat(value)
        const priceFloat = float.toFixed(this.decimals)
        const factoredPrice = priceFloat * this.factor
        if (this.maxValue >= factoredPrice && this.minValue <= factoredPrice) {
          this.$emit('updateSliderValue', factoredPrice)
        }
      } catch (e) {
        console.error(e)
      }
    }, 800),
  },
})
</script>
<style scoped>
.priceContainer {
  width: 100%;
}

.price-text-field {
  max-width: 120px;
}
</style>
